import { useState, useEffect } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { Loading } from '../loading';
import { PillButtons, Input, Button } from '../input';
import { Modal } from '../modal';
import { styles, colors, includeContentOptions } from '../../constants';
import { Timer } from './Timer';

const Result = ({ type, content, link }) => {
  const [content_, setContent_] = useState('');
  const [loading, setLoading] = useState();

  useEffect(() => {
    if (!link) {
      return;
    }
    if (content) {
      setContent_(content);
      return;
    }

    setLoading(true);
    fetch(link)
      .then((resp) => resp.text())
      .then((text) => {
        setLoading(false);
        setContent_(text);
      });
  }, [content, link]);

  let rendered;
  if (content?.join && ['urls', 'images'].includes(type)) {
    rendered = content.join('\n');
  } else if (typeof content == 'string') {
    rendered = content;
  } else {
    rendered = JSON.stringify(content, null, 2);
  }

  const maxHeight = 400;
  const borderRadius = 5;
  const pre = (content, style = {}) => (
    <pre
      style={{
        padding: 10,
        border: '1px solid #e3e3e3',
        background: '#f6f6f6',
        opacity: loading ? 0.5 : 1,
        borderRadius,
        maxHeight,
        ...style,
      }}
    >
      {content?.join && ['urls', 'images'].includes(type) ? content.join('\n') : content}
    </pre>
  );

  const maxWidth = 880;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <div style={{ position: 'relative', maxWidth }}>
        {pre(content_, { overflow: 'scroll', maxWidth })}
        <div
          style={{
            fontSize: 12,
            position: 'absolute',
            right: 2,
            top: 2,
            background: '#f6f6f6',
            borderRadius,
            padding: 8,
          }}
        >
          <a href={link} target="_blank">
            <FaExternalLinkAlt />
          </a>
        </div>
      </div>
    </div>
  );
};

const SingleVisitResult = ({ job, results, timer }) => {
  const [tab, setTab] = useState('markdown');

  if (!results) {
    return null;
  }

  const choices = includeContentOptions.filter(
    ([field]) => Object.keys(results).includes(field) || Object.keys(results?.links || {}).includes(field),
  );
  choices.push(['timer', 'Timer']);

  let node;

  switch (tab) {
    case 'timer':
      node = <Timer timer={timer || results.timer} />;
      break;

    default:
      node = <Result type={tab} content={results && results[tab]} link={results.links && results.links[tab]} />;
      break;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <PillButtons value={tab} onChange={setTab} choices={choices} />
      {node}
    </div>
  );
};

const MultiVisitResult = ({ job }) => {
  const [index, setIndex] = useState(0);

  const urls = job.results.map((it) => it.url);

  const width = 360;

  const buttons = urls.map((url, idx) => {
    const active = index == idx;
    const style = {
      fontSize: 12,
      color: '#555',
      cursor: 'pointer',
      padding: '4px 8px',
      borderRadius: 5,
      width,
      ...styles.textOverflowStyle,
    };
    if (active) {
      style.color = 'black';
      style.fontWeight = 'bold';
    }
    return (
      <div key={idx} style={style} onClick={() => setIndex(idx)}>
        {url}
      </div>
    );
  });

  return (
    <div style={{ display: 'flex', gap: 20 }}>
      <div style={{ display: 'flex', flexDirection: 'column', borderRadius: 5, width, ...styles.textOverflowStyle }}>
        {buttons}
      </div>
      <div style={{ overflowX: 'hidden', width: '100%' }}>
        <SingleVisitResult job={job} results={job.results[index]} timer={job.timer} />
      </div>
    </div>
  );
};

export const VisitResults = ({ job }) => {
  if (!job) {
    return null;
  }

  let node;
  if (Array.isArray(job.results)) {
    node = <MultiVisitResult job={job} />;
  } else {
    node = <SingleVisitResult job={job} results={job} timer={job.timer} />;
  }

  return (
    <div>
      {node}
      {/*
      <pre>{JSON.stringify(job, null, 2)}</pre>
      */}
    </div>
  );
};
